// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8aB9X","maxWidthWrapper":"styles_maxWidthWrapper__vDrQD","logos":"styles_logos__ihqZV"};